import React, { useEffect, useState, useRef } from "react";
import {
  useModalAttributes,
  useFocusFinders,
  makeStyles,
  Button,
  Input,
  Checkbox,
  Dropdown,
  Option,
  useId,
  OptionOnSelectData,
  SelectionEvents,
  Text,
  InputProps
} from "@fluentui/react-components";
import { ResourceSpaceType } from "../../APIService/ResourceSpaceTypeListService";
import { DatePicker, DatePickerProps, TimePicker } from "antd";
import { MdOutlineLock } from "react-icons/md";
import { FaRegClock } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { CustomTimePicker } from "../sample/timePicker";
import { RiRepeatFill } from "react-icons/ri";
import { PiNote } from "react-icons/pi";
import { BsFillPersonFill } from "react-icons/bs";
import { GoHome } from "react-icons/go";
import { IoMdClose } from "react-icons/io";
import { IoMdAddCircleOutline } from "react-icons/io";
import { MdPeople } from "react-icons/md";
import { LuMapPin } from "react-icons/lu";
import { FaSave } from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";
import "./ResourceSpaceTypeModel.css";
import ResourceSpaceMapSection from "./ResourceSpaceMapSection";
import ResourceSpaceFindSection from "./ResourceSpaceFindSection";
import { type } from "os";
// import { useEffect, useRef } from "react";
import dayjs from 'dayjs';
import { getSettings } from "../../viewmodel/getsettings";
import moment from "moment";
import { getDaySuffix, getOrdinal, getWeekOfMonth } from "../../utils/DateHelper"
import SearchService, { Equipment, GetAvailableResourceListRequest, GetEquipmentListResponse, GetTagsListResponse, Resource } from "../../APIService/SearchService";
import { CommonInfo } from "../../CommonData/Config";

type ResourceSpaceTypeModelProps = {
  spaceDetails: ResourceSpaceType;
  allSpaceTypes: ResourceSpaceType[];
  selectedDate: Date,
  onCloseModel: () => void;
};

const useStyles = makeStyles({
  container: {
    position: "fixed",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    inset: "0",
    overflow: "unset",
    display: "flex",
    flexDirection: "column",
    // height: "100%",
  },
  dialog: {
    margin: "20px 100px",
    height: "calc(100vh - 40px)",
    width: "calc(100vw - 200px)",
    border: "2px solid #525252",
    borderRadius: "5px",
    backgroundColor: "#1A1A1A",
    boxShadow: "0px 4px 10px 4px #00000040"
  },

  footer: {
    display: "flex",
    marginTop: "auto",
    justifyContent: "end",
    gap: "5px",
  },

  optionContainer: {
    width: "100%",
    margin: "0px 15px 15px 15px",
  },

  textInput: {
    width: "90%",
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    margin: "10px 0px -5px 0px",
  },

  dropDownContainer: {
    display: "flex",
    alignItems: "center",
    margin: "15px 30px 0px 0px",
  },

  dropDown: {
    width: "100%",
  },

  timePickerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    margin: "10px 30px 0px 30px",
    // justifyContent: "space-evenly",
    height: "30px"
  },

  timePicker: {
    flex: 1,
    minWidth: 0,
    height: "30px"
    // width: "40%",
  },

  profileContainer: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0px 0px 0px",
  },

  profile: {
    display: "flex",
    backgroundColor: "blue",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "3px 5px 3px 5px",
    borderRadius: "5px",
  },

  iconContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    alignItems: "center",
  },

  closeIcon: {
    display: "none",
  },

  bookingScroll: {
    borderRight: "1px solid #525252",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden"
  },
  endDate: {
    display: "flex",
    alignItems: "center",
    height: "32px",
    justifyItems: "center",
    justifyContent: "center",
    flex: 1
  },
  separator: {
     width: "24px",
     height: "30px",
     display: "flex",
     alignItems: "center",
     justifyContent: "center"
  },

  endDateLabel: {
    width: "70px",
    height: "20px",
    fontSize: "14px",
    lineHeight: "20px",
    flexWrap: "nowrap"
  },
});

const ResourceSpaceSideBar = ({
  isFind,
  setIsFind,
  theme
}: {
  isFind: boolean;
  theme: string;
  setIsFind: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <>
      <div className="sideBar">
        <div className="sideBarContent" onClick={() => setIsFind(true)}>
          <div
            style={{
              backgroundColor: isFind ? "#02417a" : "",
              padding: isFind ? "5px 10px 5px 10px" : 0,
              borderRadius: 20,
            }}
          >
            <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/findlight.svg' : '/find.svg'}`} style={{ width: 22, height: 22 }} />
          </div>
          <span>Find</span>
        </div>
        <div className="sideBarContent" onClick={() => setIsFind(false)}>
          <div
            style={{
              backgroundColor: !isFind ? "#02417a" : "",
              padding: !isFind ? "5px 10px 5px 10px" : 0,
              borderRadius: 20,
            }}
          >
            <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/maplight.svg' : '/map.svg'}`} style={{ width: 22, height: 22 }} />
          </div>
          <span>Map</span>
        </div>
      </div>
    </>
  );
};

type ResourceSpaceBookingValuesProps = {
  selectedDate: Date;
  theme: string;
  onDateChange: (date: Date) => void;
  onBookingTitleChange: (text: string) => void;
  onClose: () => void;
  onSave: () => void;
}

type RecurringOption = {
  label: string;
  value: number;
};

const ResourceSpaceBookingValues = (
  { 
    selectedDate, 
    theme, 
    onDateChange, 
    onClose, 
    onSave,
    onBookingTitleChange
  }: ResourceSpaceBookingValuesProps) => {
  const styles = useStyles();
  const dropdownId = useId("dropdown-default");
  const options = [
    "Custom",
    "AM",
    "PM",
    "End of day",
    "Working day",
    "All day",
  ];

  const [recurringOptions, setRecurringOptions] = useState<RecurringOption[]>([]);
  const [selectedRecurring, setSelectedRecurring] = useState<RecurringOption | null>(null);
  const getSettingsData = getSettings;

  useEffect(() => {
    setRecurringOptions(getRecurringOptionsForDate(selectedDate));
  }, [selectedDate]);

  const isDayDisabled = (date: any) => {
    const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
    const dayOfWeek = dayjs(date).format('dddd');
    return workingDays[dayOfWeek] === false;
  };

  const handleDateSelect: DatePickerProps['onChange'] = async (date: any, dateString: any) => {
    const newDate = moment(date.$d).startOf('day');
    onDateChange(newDate.toDate());
  }

  const getRecurringOptionsForDate = (date: Date) => {
    const dayOfMonth = date.getDate();
    const weekdayIndex = date.getDay();
    const weekdayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const monthName = date.toLocaleDateString("en-US", { month: "long" });
    const weekOfMonth = getWeekOfMonth(date);

    return [
      {
        label: "Never",
        value: 0,
      },
      {
        label: "Every day",
        value: 1,
      },
      {
        label: "Every working day",
        value: 2,
      },
      {
        label: `Every ${weekdayName}`,
        value: 3,
      },
      {
        label: `Every ${getOrdinal(weekOfMonth)} ${weekdayName}`,
        value: 4,
      },
      {
        label: `Day ${dayOfMonth} of every month`,
        value: 5,
      },
      {
        label: `Every ${dayOfMonth}${getDaySuffix(dayOfMonth)} ${monthName}`,
        value: 6,
      },
    ];
  };

  const onBookingOptionsSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    console.log("onBookingOptionsSelect: ", data);

    if (data.optionValue === "Custom") {
      console.log("Start Time: ", getStartTime(data.optionValue));
    }
  };

  const getStartTime = (option: string) => {
    if (option === "Custom") { return moment().format("hh:mm a");}
   };

  const getEndTime = () => { };

  const onReccuringOptionsSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    const selected = recurringOptions.find(
      (option) => option.label === data.optionText
    ) ?? null;

    console.log("Selected Recurring Option:", selected);
    setSelectedRecurring(selected);
  };

  const onChangeTitle: InputProps["onChange"] = (ev, data) => {
    onBookingTitleChange(data.value);
  }

  return (
    <div className="wrapper">
      <div className={styles.optionContainer}>
        <Input
          size="large"
          appearance="underline"
          placeholder="Add title..."
          className={styles.textInput}
          onChange={onChangeTitle}
        />
        <div className={styles.row}>
          <MdOutlineLock size={20} style={{ marginRight: "10px" }} />
          <Checkbox label="Private" />
        </div>
        <div className="datePickerContainer darkdate">
          <FiCalendar size={20} style={{ marginRight: '10px', marginTop: '10px' }} />
          <DatePicker value={dayjs(selectedDate)} disabledDate={isDayDisabled} minDate={dayjs(new Date())} onChange={handleDateSelect} />
        </div>
        <div className={styles.dropDownContainer}>
          <FaRegClock size={20} style={{ marginRight: "10px" }} />
          <div className={styles.dropDown}>
            <Dropdown id={dropdownId} defaultValue={"Custom"} onOptionSelect={onBookingOptionsSelect}>
              {options.map((option) => (
                <Option key={option}>{option}</Option>
              ))}
            </Dropdown>
          </div>
        </div>
        <div className={styles.timePickerContainer}>
          <div className={styles.timePicker}>
            <CustomTimePicker style={{height: 30}}/>
          </div>
          <div className={styles.separator}>-</div>
          <div className={styles.timePicker}>
            <CustomTimePicker style={{height: 30}}/>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "10px 30px 0px 0px",
            width: "100%",
            gap: "10px",
          }}
        >
          {/* Row 1: icon + recurring dropdown */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "10px 30px 0px 0px",
            }}
          >
            <RiRepeatFill size={20} />

            <div style={{ flex: 1 }}>
              <Dropdown
                id={dropdownId}
                defaultValue="Make recurring"
                onOptionSelect={onReccuringOptionsSelect}
                style={{ width: "100%" }}
              >
                {recurringOptions.map((option) => (
                  <Option key={option.label}>{option.label}</Option>
                ))}
              </Dropdown>
            </div>
          </div>

          {/* Row 2: End date */}
          {selectedRecurring && selectedRecurring.label !== "Never" && (
            <div style={{display: "flex", alignItems: "center", height: "32px", marginLeft: "30px", marginRight: "30px" }}>
              <Text className={styles.endDateLabel}>End date</Text>

              <div className="endDatePickerContainer darkdate" style={{marginTop: -13}}>
                <DatePicker value={dayjs(selectedDate)} disabledDate={isDayDisabled} minDate={dayjs(new Date())} onChange={handleDateSelect} />
              </div>
            </div>
          )}
        </div>

        <div className="textAreaContainer">
          <PiNote size={21} style={{ marginRight: "10px" }} />
          <div className="textArea textAreaDark">
            <TextArea />
          </div>
        </div>
        <div className={styles.profileContainer}>
          <BsFillPersonFill size={21} style={{ marginRight: "10px" }} />
          <div className="profile">
            <span style={{ fontSize: 15 }}>Subramaniyam(you)</span>
            <div className="iconContainer">
              <GoHome size={20} />
              <div className="closeIcon">
                <IoMdClose size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.profileContainer}>
          <MdPeople size={21} style={{ marginRight: "10px" }} />
          <div className="profile">
            <span style={{ fontSize: 15 }}>Add attendee</span>
            <div className="iconContainer">
              <IoMdAddCircleOutline size={18} />
            </div>
          </div>
        </div>
        <div className={styles.profileContainer}>
          <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/maplight.svg' : '/map.svg'}`} style={{ width: 22, height: 22, marginRight: 10 }} />
          <div className="profile">
            <span style={{ fontSize: 15 }}>Add workspace</span>
            <div className="iconContainer">
              <IoMdAddCircleOutline size={18} />
            </div>
          </div>
        </div>
      </div>
      <div className="actionButtons">
        <Button shape="circular" onClick={onClose} style={{ width: 'fit-content', height: 'fit-content', paddingLeft: 15, paddingTop: 7, paddingRight: 15, paddingBottom: 7 }}>
          Close
        </Button>

        <Button
          shape="circular"
          icon={<FaSave size={20} />}
          iconPosition="before"
          className="bg-success"
          style={{ width: 'fit-content', height: 'fit-content', paddingLeft: 15, paddingTop: 7, paddingRight: 15, paddingBottom: 7 }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

const ResourceSpaceTypeModel = ({
  spaceDetails,
  allSpaceTypes,
  selectedDate,
  onCloseModel
}: ResourceSpaceTypeModelProps) => {
  const styles = useStyles();
  const getSettingsData = getSettings;
  const theme = localStorage.getItem("Theme");
  const [open, setOpen] = React.useState(true);
  const [isFind, setIsFind] = useState(false);
  const [bookingDate, setBookingDate] = useState<Date>(new Date());
  const [searchTags, setSearchTags] = useState<string[]>([]);
  const [equipmentList, setEquipmentList] = useState<Equipment[]>([]);
  const [availableResourceList, setAvailableResourceList] = useState<Resource[]>([]);
  const { triggerAttributes, modalAttributes } = useModalAttributes({
    legacyTrapFocus: true,
    trapFocus: true,
  });
  const { findFirstFocusable } = useFocusFinders();
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const dialogRef = React.useRef<HTMLDivElement>(null);

  //Selected values
  const [selectedSpaceType, setSelectedSpaceType] = useState<ResourceSpaceType>(spaceDetails);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedEquipments, setSelectedEquipments] = useState<Equipment[]>([]);

  const [searchText, setSearchText] = useState<string>("");
  const [bookingTitle, setBookingTitle] = useState<string>("");
  const [occupancyCount, setOccupancyCount] = useState(0);

  useEffect(() => {
    setBookingDate(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    const fetchData = async () => {
      const locationId =
        getSettingsData.data.DefaultLocation?.LocationId ?? null;

      const [tags, equipment, resources] = await Promise.all([
        SearchService.getSearchTagsList({ LocationId: locationId }),
        SearchService.getSearchEquipmentList({ LocationId: locationId }),
        SearchService.getAvailableResourceList({ Spacetype: [selectedSpaceType.name] }),
      ]);

      setSearchTags(tags.Tags ?? []);
      setEquipmentList(equipment.ResEquipments ?? []);
      setAvailableResourceList(resources.SearchResultObjects ?? []);
    };

    fetchData();
  }, []);


  const onClickClose = () => {
    setOpen(false);
    triggerRef.current?.focus();
    onCloseModel();
  };

  const onDialogKeydown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") {
      setOpen(false);
      triggerRef.current?.focus();
    }
  };

  useEffect(() => {
    if (open && dialogRef.current) {
      findFirstFocusable(dialogRef.current)?.focus();
    }
  }, [open, findFirstFocusable]);

  useEffect(() => {
    setOpen(true);
  }, [spaceDetails]);

  const handleBookingDateChange = (date: Date) => {
    setBookingDate(date);
  }

  const getAvailableResources = async ({
    text,
    spaceType,
    equipments,
    tags,
    occupancy
  }: {
    text?: string;
    spaceType?: ResourceSpaceType;
    equipments?: Equipment[];
    tags?: string[];
    occupancy?: number;
  } = {}) => {
    const resolvedSearchText = text ?? searchText;
    const resolvedSpaceType = spaceType ?? selectedSpaceType;
    const resolvedEquipments = equipments ?? selectedEquipments;
    const resolvedTags = tags ?? selectedTags;
    const resolvedOccupancy = occupancy ?? occupancyCount;
    try {
      const payload: GetAvailableResourceListRequest = {
        Search: resolvedSearchText,
        Spacetype: [resolvedSpaceType.name],
        Equipment: resolvedEquipments.map(e => e.name),
        Keywords: resolvedTags,
        Occupancy: resolvedOccupancy
      }

      const availableResources = await SearchService.getAvailableResourceList(payload);
      setAvailableResourceList(availableResources.SearchResultObjects ?? []);
    } catch (error) {
      console.error("Failed to fetch available space resources with error: ", JSON.stringify(error));
    }
  };

  const onSearchTextChange = (text: string) => {
    setSearchText(text);
    getAvailableResources({ text: text });
  };

  const onBookingTitleChange = (text: string) => {
    setBookingTitle(text);
  };

  const onSpaceTypeChange = (selectedSpaceType: ResourceSpaceType) => {
    setSelectedSpaceType(selectedSpaceType);
    getAvailableResources({ spaceType: selectedSpaceType });
  };

  const onEquipmentsSelected = (selectedEquipments: Equipment[]) => {
    setSelectedEquipments(selectedEquipments);
    getAvailableResources({ equipments: selectedEquipments });
  };

  const onTagsSelected = (selectedTags: string[]) => {
    setSelectedTags(selectedTags);
    getAvailableResources({ tags: selectedTags });
  };

  const onOccupancyChange = (count: number) => {
    setOccupancyCount(count);
    getAvailableResources({ occupancy: count });
  }

  return (
    <div>
      {open && (
        <div
          onKeyDown={onDialogKeydown}
          ref={dialogRef}
          {...modalAttributes}
          aria-modal="true"
          role="dialog"
          className={styles.container}
        >
          <div
            className={styles.dialog}
            style={{
              display: "grid",
              gridTemplateColumns: "64px 1px 375px 1px auto",
              height: "100%",
              overflow: "hidden"
            }}
          >
            <div
              style={{ 
                borderRight: "1px solid #525252"
              }}
            >
              <ResourceSpaceSideBar isFind={isFind} setIsFind={setIsFind} theme={theme ?? 'light'} />
            </div>

            <div style={{}} />

            <div
              className={styles.bookingScroll}
            >
              <ResourceSpaceBookingValues 
                theme={theme ?? "light"} 
                selectedDate={bookingDate} 
                onDateChange={handleBookingDateChange} 
                onBookingTitleChange={onBookingTitleChange}
                onClose={onClickClose} 
                onSave={() => { setOpen(false); }} 
              />
            </div>

            <div style={{}} />

            <div>
              {isFind ? (
                <div
                  style={{
                    // overflow: "hidden",
                    // display: "flex",
                    // flexDirection: "column",
                    borderRight: "1px solid #525252"
                  }}
                >
                  <ResourceSpaceFindSection
                    spaceType={selectedSpaceType}
                    spaceTypes={allSpaceTypes}
                    equipmentList={equipmentList}
                    tagsList={searchTags}
                    availableResourceList={availableResourceList}
                    onChangeSearchText={onSearchTextChange}
                    onChangeSpaceType={onSpaceTypeChange}
                    onEquipmentSelect={onEquipmentsSelected}
                    onTagsSelect={onTagsSelected}
                    selectedEquipmentList={selectedEquipments}
                    selectedTagsList={selectedTags}
                    onChangeOccupancyCount={onOccupancyChange}
                    occupancyCount={occupancyCount}
                  />
                </div>
              ) : (
                <div
                  style={{
                    // backgroundColor: theme === "dark" ? "#141414" : "#fff",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <ResourceSpaceMapSection />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResourceSpaceTypeModel;
